import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import UserService from './services/UserService';
// import { ConfigProvider as ConfigProvider5 } from 'antd-v5';

import './i18n/i18n';
import './antd.config';

const renderApp = () =>
    ReactDOM.render(
        // <ConfigProvider5 prefixCls="ant5">
        <App />,
        // </ConfigProvider5>,
        document.getElementById('app')
    );

if (process.env.REACT_APP_UNDER_MAINTENANCE === 'true') {
    renderApp();
} else {
    UserService.initKeycloak(renderApp);
}

reportWebVitals();
